/* eslint-disable arrow-body-style */
/* eslint-disable camelcase */
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import axios from 'axios';
import { Container, Grid, Typography, Stack } from '@material-ui/core';
import UserTable from '../components/admin/UserTable';
import Page from '../components/Page';
import { getIDToken } from '../components/authentication/login/amplify';
import UserDetailsModal from '../components/admin/user/UserDetailsModal';

export default function Teams() {
  const [userList, setUserList] = useState([]);

  const [userDetailsModal, setUserDetailsModalOpen] = useState(false);
  const [modalUser, setModalUser] = useState('');
  const identity = useSelector((state) => state.identity.value);

  useEffect(() => {
    // initial call to get racklist when identity is updated
    updateUsers();
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [identity]);

  const updateUsers = async () => {
    // initial call to get racklist when identity is updated
    const jwt = await getIDToken();
    if (jwt) {
      fetchUsers(jwt, identity);
    }
  };

  const fetchUsers = (jwt, identity) => {
    if (identity !== '') {
      axios
        .get(`${process.env.REACT_APP_API}/admin/users`, {
          headers: {
            Authorization: `Bearer ${jwt}`
          }
        })
        .then((response) => {
          setUserList(response.data);
          return response.data;
        })
        .catch((error) => {
          console.error('failed to get list of users ', error.message);
        });
    }
  };

  return (
    <Page title="Admin | Users | Virtual Racks">
      <UserDetailsModal
        user={modalUser}
        isOpen={userDetailsModal}
        closeHandler={() => {
          setUserDetailsModalOpen(false);
        }}
      />
      <Container maxWidth={false}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Stack direction="row" justifyContent="space-between">
              <Typography variant="h4">Users</Typography>
            </Stack>
          </Grid>
          <Grid item xs={12}>
            <UserTable
              users={userList}
              variant="admin"
              openModal={setUserDetailsModalOpen}
              setModalUser={setModalUser}
              minWidth={800}
            />
          </Grid>
        </Grid>
      </Container>
    </Page>
  );
}
